import { render, staticRenderFns } from "./CPTemp12.vue?vue&type=template&id=a635e4fa&scoped=true&"
import script from "./CPTemp12.vue?vue&type=script&lang=js&"
export * from "./CPTemp12.vue?vue&type=script&lang=js&"
import style0 from "./CPTemp12.vue?vue&type=style&index=0&id=a635e4fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a635e4fa",
  null
  
)

export default component.exports